import { css } from 'styled-components';

const skinsGroupage = {
  groupage0: '#87e8e3',
  groupage1: '#cfaaff',
  groupage2: '#f5e389',
  groupage3: '#b7f288',
  groupage4: '#6797fe',
  groupage5: '#febc77',
  groupage6: '#e8878c',
  groupage7: '#daffaa',
  groupage8: '#899bf5',
  groupage9: '#c388f2',
  groupage10: '#fece67',
  groupage11: '#77b9fe',
};

const storeColor = 'var(--grey700)';
const aggregatedColor = 'var(--primary900)';

const groupageBackground = css`
  background: ${(props) => {
    if (props.store) {
      return storeColor;
    }
    if (props.isAggregated) {
      return aggregatedColor;
    }
    return skinsGroupage[props.skin] || 'transparent';
  }};
`;

export { groupageBackground, skinsGroupage, storeColor, aggregatedColor };
